<template>
  <aside class="aside-menu">

  </aside>
</template>

<script>
export default {
  name: 'aside'
}
</script>



// WEBPACK FOOTER //
// Aside.vue?773b2774